export const baseConfig = {
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-type': 'application/json',
    // If you use ngrok you need this code
    // 'ngrok-skip-browser-warning': 'true',
  },
};
